import { PMS_APIs } from 'src/configs/API'
import { toCapitalCase } from 'src/utils/common'
import request from 'src/utils/request'
import useSWR from 'swr'

const queryDistricts = (provinceID) => {
	var districts = localStorage.getItem(`districts`);
	if (!districts) {
		return request.pmsApi({
			url: PMS_APIs.API_GET_DISTRICTS_BY_PROVINCEID,
			method: 'POST',
			data: {
				ID: provinceID,
			},
		})
	} else {
		return Promise.resolve({
			districts: JSON.parse(districts).districts.filter(e => e.provinceID == provinceID),
			errorMessage: "",
			errors: [],
			isError: false,
		});
	}
}

const queryCities = async () => {
	var provinces = localStorage.getItem(`provinces`);
	if (!provinces) {
		return request.pmsApi({
			url: PMS_APIs.API_GET_PROVINCES,
			data: {
				ID: 'VN',
			},
			method: 'POST',
		})
	} else {
		return Promise.resolve({
			provinces: JSON.parse(provinces).provinces.filter(e => e.countryID === 'VN'),
			errorMessage: '',
			errors: [],
			isError: false,
		});

	}
}
const queryCitiesByCountryID = async (countryID) => {
	var provinces = localStorage.getItem(`provinces`);
	
	if (!provinces) {
		// return request.pmsApi({
		// 	url: PMS_APIs.API_GET_PROVINCES,
		// 	data: {
		// 		ID: countryID,
		// 	},
		// 	method: 'POST',
		// })
		 const result = await request.pmsApi({
            url: PMS_APIs.API_GET_PROVINCES,
            data: {
                ID: countryID,
            },
            method: "POST",
        });
        localStorage.setItem("provinces", JSON.stringify(result?.provinces));
        return result;
	} else {
		return Promise.resolve({
			provinces: JSON.parse(provinces).provinces.filter(e => e.countryID === countryID),
			errorMessage: "",
			errors: [],
			isError: false,
		});
	}
		// return request.pmsApi({
		// 	url: PMS_APIs.API_GET_PROVINCES,
		// 	data: {
		// 		ID: countryID,
		// 	},
		// 	method: 'POST',
		// })
}

const queryCountry = async () => {
	var countries = localStorage.getItem(`countries`);
	if (!countries) {
		return request.pmsApi({
			url: PMS_APIs.API_GET_COUNTRIES,
			data: {},
			method: 'POST',
		})
	} else {
		return Promise.resolve({
			countries: JSON.parse(countries).countries,
			errorMessage: "",
			errors: [],
			isError: false,
		});
	}
}

const queryWards = (districtID) => {
	var wards = localStorage.getItem(`wards`);
	if (!wards) {
		return request.pmsApi({
			url: PMS_APIs.API_GET_WARDS_BY_DISTRICTID,
			method: 'POST',
			data: {
				ID: districtID,
			},
		})
	} else {
		return Promise.resolve({
			wards: JSON.parse(wards).wards.filter(e => e.districtID == districtID),
			errorMessage: "",
			errors: [],
			isError: false,
		});
	}
}
const queryWardsByProvinceId = (provinceId) => {
	return request.pmsApi({
		url: PMS_APIs.API_GET_WARDS_BY_PROVINCEID,
		method: 'POST',
		data: {
			ID: provinceId,
		},
	})
}
const usePMSCities = () => {
	const { data, error } = useSWR(`PMS_Cities`, queryCities, {
		dedupingInterval: 1200000,
	})

	const capitalCities =
		data?.provinces
			?.filter((e) => e.isActive && e.provinceID !== 'VN')
			.map((e) => ({ ...e, provinceName: toCapitalCase(e.provinceName) })) || []

	return {
		cities: capitalCities,
		isLoading: !error && !data,
		isError: error,
	}

}

const usePMSDistricts = (provinceID) => {
	const { data, error } = useSWR(
		provinceID ? `PMS_Districts_${provinceID}` : null,
		() => queryDistricts(provinceID),
		{
			dedupingInterval: 1200000,
		}
	)

	return {
		districts: data?.districts,
		isLoading: !error && !data,
		isError: error,
	}
}

const usePMSCountry = () => {
	const { data, error } = useSWR('PMS_Country', () => queryCountry(), {
		dedupingInterval: 1200000,
	})

	return {
		countries: data?.countries,
		isLoading: !error && !data,
		isError: error,
	}
}

const addressServices = {
	queryDistricts,
	queryWards,
	queryWardsByProvinceId,
	usePMSCities,
	usePMSDistricts,
	queryCountry,
	queryCitiesByCountryID,
	usePMSCountry,
}

export default addressServices
